import * as React from "react"
const SvgComponent = (props) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    xmlSpace="preserve"
    style={{
      shapeRendering: "geometricPrecision",
      textRendering: "geometricPrecision",
      imageRendering: "optimizeQuality",
      fillRule: "evenodd",
      clipRule: "evenodd",
    }}
    viewBox="0 0 28738 28738"
    {...props}
  >
    <path
      d="M2242 12637h10395V2242c0-953 779-1732 1732-1732s1732 779 1732 1732v10395h10395c953 0 1733 779 1733 1732s-780 1732-1733 1732H16101v10395c0 953-779 1733-1732 1733s-1732-780-1732-1733V16101H2242c-953 0-1732-779-1732-1732s779-1732 1732-1732z"
      style={{
        fill: "#1c1b17",
        stroke: "#2b2a29",
        strokeWidth: 1019.08,
      }}
      className="stroke1 fill"
    />
  </svg>
)
export default SvgComponent
